var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ContentDisplay',{attrs:{"data-testid":"partner-card"},scopedSlots:_vm._u([{key:"content-block-1",fn:function(){return [_c('ListDisplay',{attrs:{"align-vertical":"","value-as-bold":"","title":"Especialista responsável","value":_vm.partnerName}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }